const INSTALLATION_TYPE = {
  PRO: 'pro',
  SELF: 'self',
};

export default INSTALLATION_TYPE;
